import React from "react";
import { useSelector } from "react-redux";
import { useResource } from "../../../Resources/useResource";
import { AppsLauncherResources } from "../../../Resources/AppsLauncherResources";
import { AppAuthState, AppAuthStatusEnum } from "../../../Redux/AppAuthReducer";
import { useLauncherApps } from "./useLauncherApps";
import AppsLauncherView from "./AppsLauncherView";

const AppsLauncher: React.FC = () => {
  const isAuthenticated = useSelector(
    (s: { auth?: AppAuthState }) => s.auth?.status === AppAuthStatusEnum.AUTHENTICATED,
  );
  const strings = useResource(AppsLauncherResources);
  const apps = useLauncherApps(isAuthenticated);
  if (!isAuthenticated) return null;
  return <AppsLauncherView apps={apps} strings={strings} variant="header" />;
};

export default AppsLauncher;
